import { render, staticRenderFns } from "./PitchActions.vue?vue&type=template&id=832d0fea&scoped=true"
import script from "./PitchActions.vue?vue&type=script&lang=js"
export * from "./PitchActions.vue?vue&type=script&lang=js"
import style0 from "./PitchActions.vue?vue&type=style&index=0&id=832d0fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832d0fea",
  null
  
)

export default component.exports